import { Outlet } from "react-router-dom";
import Sidebar from "@/components/layout/Sidebar";
import Topbar from "@/components/layout/Topbar";
import ImpersonationBanner from "@/components/layout/ImpersonationBanner";
import CacheBustButton from "@/components/layout/CacheBustButton";
import { LicenseProvider } from "@/lib/license";

export default function AppShell() {
    return (
        <LicenseProvider>
            <ImpersonationBanner />
            <div className="min-h-screen flex bg-background text-foreground">
                <Sidebar />
                <div className="flex-1 min-w-0 flex flex-col">
                    <Topbar />
                    <main className="flex-1 px-5 md:px-8 py-6 md:py-8 max-w-[1400px] w-full mx-auto animate-fade-in">
                        <Outlet />
                    </main>
                </div>
            </div>
            <CacheBustButton />
        </LicenseProvider>
    );
}
